<u-icon
  [model]="{ type: 'font', value: 'icon-Windows-close' }"
  class="icon-close"
  [styles]="{ fontSize: '12px', color: 'var(--color-text-tertiary)' }"
  (click)="onButtonClick('cancel')"
></u-icon>
<ng-container [ngSwitch]="model?.feedbackType">
  <ng-container *ngSwitchCase="'Positive'">
    <div class="free-text-wrapper">
      <ng-container *ngTemplateOutlet="freeTextTemplate"></ng-container>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'Negative'">
    <ng-container *ngIf="model?.intent === 'ResourceLookup'; else negativeWithResources">
      <div class="free-text-wrapper">
        <ng-container *ngTemplateOutlet="freeTextTemplate"></ng-container>
      </div>
    </ng-container>
    <ng-template #negativeWithResources>
      <div class="answer-feedback-negative">
        <div class="answer-subtitle">{{ answerWrongReasonContent.title }}</div>
        <div class="answer-options">
          <u-radio-button
            [options]="answerWrongReasonOptions"
            [selectedOption]="selectedAnswerOption"
            (onClick)="onRadioButtonClick($event)"
            [optionTemplate]="reasonTemplate"
          >
          </u-radio-button>
        </div>
        <ng-container *ngTemplateOutlet="freeTextTemplate"></ng-container>
      </div>
    </ng-template>
  </ng-container>
</ng-container>

<div class="buttons-container">
  <u-button
    [label]="answerWrongReasonContent.buttonsSecondaryText"
    type="secondary"
    [styles]="{ width: '96px', height: '32px' }"
    (onClick)="onButtonClick('cancel')"
  >
  </u-button>
  <u-button
    [label]="answerWrongReasonContent.buttonsPrimaryText"
    type="primary"
    [disabled]="disableSendButton"
    [styles]="{ width: '96px', height: '32px' }"
    (onClick)="onButtonClick('send')"
  >
  </u-button>
</div>

<ng-template #reasonTemplate>
  <feedback-reason-options
    #reasonOptionsList
    [option]="handleSelectedOption"
    [resources]="model?.resources"
    [intent]="model?.intent"
    (resourcesChecked)="handleResourcesChecked($event)"
  ></feedback-reason-options>
</ng-template>

<ng-template #freeTextTemplate
  ><div class="answer-free-text">
    <div class="answer-free-text-title">
      {{
        model?.feedbackType === 'Positive'
          ? answerWrongReasonContent.positiveFreeText.title
          : answerWrongReasonContent.negativeFreeText.title
      }}
    </div>
  </div>
  <ng-container *ngTemplateOutlet="textareaTemplate"></ng-container>
</ng-template>

<ng-template #textareaTemplate>
  <div class="answer-free-text-area">
    <u-textarea
      [placeholder]="
        model?.feedbackType === 'Positive'
          ? answerWrongReasonContent.positiveFreeText.placeholder
          : answerWrongReasonContent.negativeFreeText.placeholder
      "
      [maxLength]="FREE_TEXT_MAX_LENGTH"
      (onFocus)="onFocusTextarea()"
      (onBlur)="onBlurTextarea()"
      (onChange)="onChangeTextarea($event)"
      [styles]="{ width: '100%', maxHeight: '128px' }"
      [autofocus]="false"
      [ignoreEnter]="true"
    ></u-textarea>
    <span class="limit-warning" *ngIf="answerInput?.length >= FREE_TEXT_MAX_LENGTH">{{
      answerWrongReasonContent.freeTextLimitWarning
    }}</span>
  </div>
</ng-template>
